<template>
  <footer class="app-footer">
    <span class="mr-auto"><a :href="url">FASA</a> &copy; 2019</span>
    <span class="mx-auto"><strong>v{{ versao }}</strong></span>
    <span class="ml-auto">Powered by PazNet</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  data () {
    return {
      url: process.env.ROOT_URL,
      versao: process.env.APP_VERSION
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/components/Footer.vue